import { useEffect, useState } from 'react';
import './Home.min.css';
import TinySlider from "tiny-slider-react";
import TinySlider2 from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import ng2 from '../assets/images/home/HieloSeco-Nugget2.png';
import imgQHS from '../assets/images/home/HieloSeco-que-es.jpg';
import ng1 from '../assets/images/home/HieloSeco-Nugget1.png';

const icon1 = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
.st0{fill:none;stroke:#ffffff;stroke-width:15;stroke-miterlimit:10;}
.st1{fill:none;stroke:#ffffff;stroke-width:12;stroke-miterlimit:10;}
</style>
<g>
<path d="M360.4,60.4c-9.6-16.6-23-30.8-39.2-41.3C301.8,6.6,279.2,0,256,0s-45.8,6.6-65.2,19.2c-16.2,10.5-29.7,24.6-39.2,41.3
   c-55.1,3.4-98.8,49.3-98.8,105.2c0,44.1,27.3,83.1,67.8,98.4v82.3c0,8.3,6.7,15,15,15s15-6.7,15-15v-78.2l30.2,0v52.2
   c0,8.3,6.7,15,15,15s15-6.7,15-15v-52.2l30.2,0v78.2c0,8.3,6.7,15,15,15s15-6.7,15-15v-78.2l30.2,0V384c0,8.3,6.7,15,15,15
   s15-6.7,15-15V268.2l30.2,0v78.2c0,8.3,6.7,15,15,15s15-6.7,15-15v-82.3c40.4-15.4,67.8-54.3,67.8-98.5
   C459.2,109.7,415.5,63.8,360.4,60.4L360.4,60.4z M391.5,231v-83.6c0-8.3-6.7-15-15-15s-15,6.7-15,15v90.7l-30.2,0v-46.2
   c0-8.3-6.7-15-15-15s-15,6.7-15,15v46.2l-30.2,0V116.5c0-8.3-6.7-15-15-15s-15,6.7-15,15v121.7l-30.2,0v-38.6c0-8.3-6.7-15-15-15
   s-15,6.7-15,15v38.6l-30.2,0v-89.1c0-8.3-6.7-15-15-15s-15,6.7-15,15V231c-22.9-13.2-37.8-37.9-37.8-65.4
   c-0.1-42.3,35.2-76.6,77.4-75.4c6,0.2,11.5-3.2,14.1-8.6C189.2,50.3,221.3,30,256,30s66.8,20.3,81.7,51.7c2.6,5.4,8.1,8.8,14.1,8.6
   c42.3-1.2,77.5,33.1,77.4,75.4C429.2,193.1,414.4,217.8,391.5,231L391.5,231z"/>
</g>
<path className="st0" d="M256.2,476.8H152.5c-9.8,0-17.8-8-17.8-17.8v0c0-9.8,8-17.8,17.8-17.8h103.7c9.8,0,17.8,8,17.8,17.8v0
C274,468.8,266,476.8,256.2,476.8z"/>
<path className="st0" d="M286.4,437.8l-41.5-19.9c-8.8-4.2-12.6-14.9-8.3-23.7l0,0c4.2-8.8,14.9-12.6,23.7-8.3l41.5,19.9
c8.8,4.2,12.6,14.9,8.3,23.7v0C305.9,438.2,295.2,442,286.4,437.8z"/>
<path className="st0" d="M356.5,476.8h-62.3c-9.8,0-17.8-8-17.8-17.8v0c0-9.8,8-17.8,17.8-17.8h62.3c9.8,0,17.8,8,17.8,17.8v0
C374.2,468.8,366.3,476.8,356.5,476.8z"/>
<path className="st0" d="M215.8,431.4h-42.4c-9.8,0-17.8-8-17.8-17.8v-4.6c0-9.8,8-17.8,17.8-17.8h42.4c9.8,0,17.8,8,17.8,17.8v4.6
C233.5,423.4,225.5,431.4,215.8,431.4z"/>
<path d="M157.2,176.9l-25.1-25.1c-3.9-3.9-3.9-10.2,0-14l0,0c3.9-3.9,10.2-3.9,14,0l25.1,25.1c3.9,3.9,3.9,10.2,0,14l0,0
C167.3,180.8,161,180.8,157.2,176.9z"/>
<path d="M114.2,176.9l25.1-25.1c3.9-3.9,3.9-10.2,0-14l0,0c-3.9-3.9-10.2-3.9-14,0l-25.1,25.1c-3.9,3.9-3.9,10.2,0,14l0,0
C104,180.8,110.4,180.8,114.2,176.9z"/>
<path d="M217.4,227.2l-25.1-25.1c-3.9-3.9-3.9-10.2,0-14l0,0c3.9-3.9,10.2-3.9,14,0l25.1,25.1c3.9,3.9,3.9,10.2,0,14l0,0
C227.6,231.1,221.3,231.1,217.4,227.2z"/>
<path d="M174.5,227.2l25.1-25.1c3.9-3.9,3.9-10.2,0-14l0,0c-3.9-3.9-10.2-3.9-14,0l-25.1,25.1c-3.9,3.9-3.9,10.2,0,14l0,0
C164.3,231.1,170.6,231.1,174.5,227.2z"/>
<path d="M277.5,144.4l-25.1-25.1c-3.9-3.9-3.9-10.2,0-14l0,0c3.9-3.9,10.2-3.9,14,0l25.1,25.1c3.9,3.9,3.9,10.2,0,14l0,0
C287.6,148.3,281.3,148.3,277.5,144.4z"/>
<path d="M234.5,144.4l25.1-25.1c3.9-3.9,3.9-10.2,0-14v0c-3.9-3.9-10.2-3.9-14,0l-25.1,25.1c-3.9,3.9-3.9,10.2,0,14l0,0
C224.4,148.3,230.7,148.3,234.5,144.4z"/>
<path d="M337.6,219.9l-25.1-25.1c-3.9-3.9-3.9-10.2,0-14l0,0c3.9-3.9,10.2-3.9,14,0l25.1,25.1c3.9,3.9,3.9,10.2,0,14l0,0
C347.8,223.8,341.5,223.8,337.6,219.9z"/>
<path d="M294.7,219.9l25.1-25.1c3.9-3.9,3.9-10.2,0-14v0c-3.9-3.9-10.2-3.9-14,0l-25.1,25.1c-3.9,3.9-3.9,10.2,0,14v0
C284.5,223.8,290.8,223.8,294.7,219.9z"/>
<path d="M398.1,175.4l-25.1-25.1c-3.9-3.9-3.9-10.2,0-14v0c3.9-3.9,10.2-3.9,14,0l25.1,25.1c3.9,3.9,3.9,10.2,0,14l0,0
C408.2,179.3,401.9,179.3,398.1,175.4z"/>
<path d="M355.1,175.4l25.1-25.1c3.9-3.9,3.9-10.2,0-14v0c-3.9-3.9-10.2-3.9-14,0l-25.1,25.1c-3.9,3.9-3.9,10.2,0,14v0
C344.9,179.3,351.2,179.3,355.1,175.4z"/>
<path className="st1" d="M360.4,434h-34.5c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h34.5c6.6,0,12,5.4,12,12v3.6
C372.4,428.6,367,434,360.4,434z"/>
</svg>`;
const icon2 = `<svg
version="1.1"
id="Capa_1"
x="0px"
y="0px"
viewBox="0 0 309.11898 239.66999"
xml:space="preserve"
width="309.11899"
height="239.67"
xmlns="http://www.w3.org/2000/svg"
xmlns:svg="http://www.w3.org/2000/svg"><defs
id="defs861" />
<g
id="g826"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
 <path
d="m 211.044,170.163 c -0.983,0 -1.947,-0.019 -2.918,-0.064 L 6.44,170.163 c -3.554,0 -6.427,-2.873 -6.427,-6.427 0,-3.548 2.873,-6.427 6.427,-6.427 l 201.97,-0.058 c 1.06,0.039 1.844,0.058 2.641,0.058 30.258,0 54.872,-24.615 54.872,-54.872 0,-30.251 -24.615,-54.866 -54.872,-54.866 -30.251,0 -54.866,24.615 -54.866,54.866 0,7.442 1.465,14.653 4.338,21.427 1.395,3.271 -0.135,7.044 -3.393,8.432 -3.271,1.401 -7.05,-0.135 -8.432,-3.393 -3.56,-8.374 -5.366,-17.275 -5.366,-26.459 0,-37.34 30.38,-67.72 67.72,-67.72 37.34,0 67.726,30.386 67.726,67.72 -0.008,37.34 -30.394,67.719 -67.734,67.719 z m 98.074,57.643 c 0,-25.694 -20.9,-46.595 -46.595,-46.595 -0.675,0 -1.343,0.013 -1.735,0.039 L 6.433,181.211 v 0 c -3.548,0 -6.427,2.873 -6.427,6.427 0,3.548 2.879,6.427 6.427,6.427 l 254.631,0.032 1.459,-0.032 c 18.606,0 33.741,15.135 33.741,33.741 0,18.606 -15.135,33.741 -33.741,33.741 -18.606,0 -33.741,-15.135 -33.741,-33.741 0,-4.582 0.9,-9.01 2.667,-13.175 1.395,-3.265 -0.135,-7.044 -3.393,-8.432 -3.265,-1.401 -7.037,0.122 -8.432,3.393 -2.455,5.758 -3.695,11.89 -3.695,18.207 0,25.694 20.9,46.595 46.595,46.595 25.694,0 46.594,-20.894 46.594,-46.588 z M 6.433,145.06 l 75.329,-0.026 1.472,0.026 c 20.547,0 37.269,-16.723 37.269,-37.269 0,-20.546 -16.723,-37.269 -37.269,-37.269 -20.553,0 -37.276,16.723 -37.276,37.269 0,5.051 0.99,9.955 2.956,14.57 1.388,3.265 5.174,4.769 8.432,3.393 3.265,-1.395 4.788,-5.167 3.393,-8.432 -1.279,-3.014 -1.928,-6.215 -1.928,-9.531 0,-13.464 10.951,-24.416 24.422,-24.416 13.464,0 24.416,10.951 24.416,24.416 0,13.465 -10.951,24.416 -24.416,24.416 l -1.33,-0.026 -75.477,0.026 c -3.548,0 -6.427,2.879 -6.427,6.427 0.007,3.553 2.887,6.426 6.434,6.426 z m 97.476,68.555 c 0,-3.554 -2.873,-6.427 -6.427,-6.427 H 6.433 c -3.548,0 -6.427,2.873 -6.427,6.427 0,3.554 2.879,6.427 6.427,6.427 h 91.049 c 3.554,0 6.427,-2.873 6.427,-6.427 z"
id="path824"
style="fill:#ffffff;fill-opacity:1" />
</g>
<g
id="g828"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g830"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g832"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g834"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g836"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g838"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g840"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g842"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g844"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g846"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g848"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g850"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g852"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g854"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
<g
id="g856"
transform="translate(0.001,-34.724)"
style="fill:#ffffff;fill-opacity:1">
</g>
</svg>`;
const icon3 = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M466.324,63.247c-57.482-57.48-148.986-60.711-210.288-9.683C194.734,2.536,103.23,5.766,45.75,63.247
C16.247,92.748,0,131.973,0,173.695c0,41.722,16.247,80.947,45.75,110.449l210.287,210.286l210.288-210.287
C527.225,223.242,527.225,124.148,466.324,63.247z M445.108,262.927L256.036,451.998L66.966,262.927
c-23.834-23.835-36.961-55.526-36.961-89.233s13.127-65.397,36.961-89.232c24.602-24.602,56.916-36.901,89.232-36.901
s64.63,12.301,89.232,36.901l10.607,10.609l10.607-10.607c49.202-49.202,129.261-49.202,178.464,0S494.31,213.723,445.108,262.927
z"/></g></g><g><g><polygon points="302.448,215.449 283.878,252.589 228.195,141.221 191.081,215.449 126.204,215.449 126.204,245.453 
209.625,245.453 228.195,208.313 283.878,319.681 320.992,245.453 385.869,245.453 385.869,215.449"/></g></g></svg>`;
const icon4 = `<svg id="Capa_1" enable-background="new 0 0 510.947 510.947" height="512" viewBox="0 0 510.947 510.947" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Lines_46_"><path d="m274.259 145.235c0-4.339-.245-8.622-.707-12.84h34.326v-15h-36.97c-5.273-21.55-16.523-40.771-31.884-55.798l35.503-40.482-11.277-9.891-35.592 40.583c-19.547-14.765-43.851-23.531-70.163-23.531-24.282 0-46.855 7.466-65.556 20.223l-35.522-40.503-11.277 9.891 34.957 39.859c-16.669 14.811-29.089 34.312-35.177 56.421h-33.131v15h30.049c-.724 5.255-1.107 10.617-1.107 16.068v56.659h-40.731v15h40.73v81.274h-28.941v15h28.941v29.685c0 15.191 2.909 29.715 8.194 43.043h-48.924v15h56.151c7.741 13.508 18.099 25.324 30.372 34.763l-31.132 29.606 10.337 10.869 33.563-31.918c15.105 8.736 32.335 14.174 50.704 15.347v50.56h15v-50.56c18.692-1.193 36.201-6.809 51.495-15.815l37.45 35.615 10.337-10.869-35.101-33.38c10.98-8.579 20.393-19.078 27.737-30.989h62.754v-15h-54.943c6.13-14.199 9.536-29.844 9.536-46.271v-26.457h33.619v-15h-33.619v-15.819h-15v57.276c0 56.22-45.651 101.958-101.765 101.958-56.113 0-101.764-45.738-101.764-101.958v-197.619c0-56.22 45.651-101.958 101.764-101.958s101.765 45.738 101.765 101.958v89.14h15v-14.252h45.407v-15h-45.407v-59.888z"/><path d="m177.471 79.545c-28.874 0-52.364 23.526-52.364 52.443s23.49 52.443 52.364 52.443 52.364-23.526 52.364-52.443-23.49-52.443-52.364-52.443zm0 89.886c-20.603 0-37.364-16.797-37.364-37.443s16.761-37.443 37.364-37.443 37.364 16.797 37.364 37.443-16.761 37.443-37.364 37.443z"/><path d="m140.107 251.945c0-14.647-11.901-26.563-26.53-26.563-14.628 0-26.53 11.916-26.53 26.563s11.901 26.564 26.53 26.564c14.629.001 26.53-11.916 26.53-26.564zm-38.06 0c0-6.376 5.172-11.563 11.53-11.563s11.53 5.188 11.53 11.563c0 6.377-5.172 11.564-11.53 11.564-6.357.001-11.53-5.187-11.53-11.564z"/><path d="m177.471 388.562c21.49 0 38.974-17.509 38.974-39.03s-17.483-39.029-38.974-39.029-38.974 17.509-38.974 39.029c.001 21.522 17.484 39.03 38.974 39.03zm0-63.059c13.219 0 23.974 10.779 23.974 24.029s-10.754 24.03-23.974 24.03-23.974-10.78-23.974-24.03 10.755-24.029 23.974-24.029z"/><path d="m209.963 205.123h15v15h-15z"/><path d="m209.963 240.096h15v15h-15z"/><path d="m91.732 305.055h15v15h-15z"/><path d="m91.732 340.028h15v15h-15z"/><path d="m259.259 251.945h15v17.067h-15z" transform="matrix(1 -.003 .003 1 -.863 .887)"/><path d="m421.881 213.601c4.001-.001 8.06-.348 12.133-1.066 18.261-3.219 34.212-13.41 44.914-28.695 10.703-15.285 14.824-33.759 11.604-52.021l-2.639-14.962-14.771 2.605 2.639 14.962c2.524 14.314-.715 28.809-9.119 40.812s-20.917 20.003-35.232 22.527c-29.698 5.233-58.104-14.661-63.339-44.351l-12.944-73.411c-5.234-29.691 14.661-58.104 44.352-63.34 29.694-5.229 58.104 14.66 63.339 44.351l2.405 13.641 14.771-2.605-2.405-13.641c-6.672-37.836-42.884-63.192-80.715-56.517-18.261 3.219-34.212 13.41-44.914 28.695-10.703 15.285-14.824 33.76-11.604 52.021l12.944 73.412c5.951 33.762 35.42 57.584 68.581 57.583z"/><path d="m467.826 89.426.043.245 2.604 14.773.001-.001v.001l14.772-2.605-2.605-14.772-.044-.247z"/><path d="m395.427 113.29h15v15h-15z" transform="matrix(.985 -.174 .174 .985 -14.856 71.822)"/><path d="m424.973 108.081h14.999v15h-14.999z" transform="matrix(.985 -.174 .174 .985 -13.5 76.85)"/><path d="m405.077 81.634h15v14.999h-15z" transform="matrix(.985 -.174 .174 .985 -9.21 72.989)"/><path d="m465.098 292.843c-36.104-13.14-76.164 5.541-89.305 41.643l-25.496 70.05c-6.342 17.425-5.491 36.334 2.395 53.245 7.887 16.911 21.825 29.717 39.249 36.059 7.72 2.81 15.729 4.208 23.729 4.208 10.057 0 20.097-2.21 29.516-6.603 16.911-7.886 29.717-21.824 36.059-39.248l5.197-14.277-14.096-5.131-5.197 14.277c-4.971 13.659-15.022 24.592-28.303 30.784-13.278 6.193-28.115 6.865-41.774 1.894s-24.593-15.022-30.785-28.303-6.865-28.116-1.894-41.774l25.496-70.05c10.311-28.329 41.747-42.989 70.078-32.678 28.33 10.312 42.989 41.749 32.678 70.078l-4.737 13.016 14.096 5.131 4.737-13.016c13.139-36.103-5.541-76.165-41.643-89.305z"/><path d="m482.692 404.363v-.001l-5.13 14.096 14.096 5.131 5.216-14.33-14.096-5.131z"/><path d="m403.392 391.341h15v15h-15z" transform="matrix(.342 -.94 .94 .342 -104.406 648.591)"/><path d="m431.583 401.602h15v14.999h-15z" transform="matrix(.342 -.94 .94 .342 -95.519 681.79)"/><path d="m427.578 368.75h15v15h-15z" transform="matrix(.342 -.94 .94 .342 -67.278 656.421)"/></g></svg>`;
const icon5 = `<svg height="512pt" viewBox="-105 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m135.929688 331.980469v-197.761719c0-8.285156-6.714844-15-15-15-8.28125 0-15 6.714844-15 15v197.761719c-26.367188 6.703125-45.929688 30.640625-45.929688 59.070312 0 33.601563 27.332031 60.9375 60.929688 60.9375 33.597656 0 60.933593-27.335937 60.933593-60.9375 0-28.429687-19.566406-52.367187-45.933593-59.070312zm-15 90.007812c-17.054688 0-30.929688-13.878906-30.929688-30.9375 0-17.0625 13.875-30.941406 30.929688-30.941406 17.058593 0 30.933593 13.878906 30.933593 30.941406 0 17.058594-13.875 30.9375-30.933593 30.9375zm0 0"/><path d="m195.375 295.726562v-221.273437c0-41.054687-33.394531-74.453125-74.445312-74.453125-41.046876 0-74.441407 33.398438-74.441407 74.453125v221.273437c-29.25 22.863282-46.488281 57.921876-46.488281 95.320313 0 66.695313 54.25 120.953125 120.929688 120.953125 66.683593 0 120.933593-54.257812 120.933593-120.953125 0-37.398437-17.238281-72.457031-46.488281-95.320313zm-74.445312 186.273438c-50.140626 0-90.929688-40.800781-90.929688-90.953125 0-30.167969 14.921875-58.316406 39.917969-75.296875 4.109375-2.792969 6.570312-7.441406 6.570312-12.410156v-228.886719c0-24.511719 19.9375-44.453125 44.441407-44.453125 24.507812 0 44.445312 19.941406 44.445312 44.453125v228.886719c0 4.96875 2.460938 9.617187 6.570312 12.410156 24.996094 16.980469 39.917969 45.128906 39.917969 75.296875 0 50.152344-40.792969 90.953125-90.933593 90.953125zm0 0"/><path d="m286.863281 239.488281h-46.488281c-8.285156 0-15 6.714844-15 15 0 8.285157 6.714844 15 15 15h46.488281c8.28125 0 15-6.714843 15-15 0-8.285156-6.71875-15-15-15zm0 0"/><path d="m286.863281 179.476562h-46.488281c-8.285156 0-15 6.714844-15 15 0 8.285157 6.714844 15 15 15h46.488281c8.28125 0 15-6.714843 15-15 0-8.285156-6.71875-15-15-15zm0 0"/><path d="m286.863281 119.464844h-46.488281c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h46.488281c8.28125 0 15-6.714844 15-15s-6.71875-15-15-15zm0 0"/><path d="m240.375 89.453125h46.488281c8.28125 0 15-6.714844 15-15 0-8.28125-6.71875-15-15-15h-46.488281c-8.285156 0-15 6.71875-15 15 0 8.285156 6.714844 15 15 15zm0 0"/></svg>`;
const icon6 = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
<g>
<g>
   <g>
       <path d="M506.175,365.576c-4.095-10.258-15.729-15.255-25.987-11.16c-10.258,4.095-15.255,15.729-11.16,25.987
           c5.206,13.043,3.499,27.935-4.567,39.839c-8.07,11.91-20.991,18.741-35.449,18.741H83.068c-15.771,0-29.776-8.229-37.465-22.015
           c-7.701-13.809-7.339-30.082,0.968-43.533L219.543,93.382c7.876-12.752,21.519-20.365,36.497-20.365
           c14.978,0,28.62,7.613,36.497,20.365l127.927,207.124c5.804,9.397,18.128,12.312,27.523,6.505
           c9.396-5.803,12.31-18.126,6.505-27.523L326.564,72.364c-15.216-24.636-41.58-39.344-70.525-39.344s-55.309,14.709-70.525,39.344
           L12.542,352.418c-16.036,25.966-16.734,57.38-1.869,84.033c14.853,26.63,41.916,42.528,72.395,42.528h345.944
           c27.938,0,52.927-13.233,68.56-36.303C513.088,419.778,516.303,390.955,506.175,365.576z"/>
       <path d="M256.049,399.987c11.045,0,19.998-8.953,19.998-19.998c0-11.045-8.953-19.998-19.998-19.998h-0.01
           c-11.045,0-19.993,8.953-19.993,19.998C236.046,391.034,245.004,399.987,256.049,399.987z"/>
       <path d="M276.038,309.995V163.008c0-11.045-8.953-19.998-19.998-19.998c-11.045,0-19.998,8.953-19.998,19.998v146.987
           c0,11.045,8.953,19.998,19.998,19.998C267.085,329.993,276.038,321.04,276.038,309.995z"/>
   </g>
</g>
</g></svg>`;

export default function Home() {
    const [yPos, setYPos] = useState(0)
    useEffect(() => {
        const handleScroll = () => {
            // let $speed
            // if( window.innerWidth > 991 ) {
            //     $speed = .2
            // } else {
            //     $speed = .1
            // }
            let $wTop = window.scrollY
            const im1 = document.querySelector('#ng1')
            const im2 = document.querySelector('#ng2')
            setYPos($wTop * .2)
            im1.style.transform = "translateY(" + yPos + "px)"
            im2.style.transform = "translateY(" + yPos + "px)"
        }
        window.removeEventListener('scroll', handleScroll)
        window.addEventListener('scroll', handleScroll, {passive: true});

        return () => window.removeEventListener('scroll', handleScroll)
    }, [yPos])
    // const setPos = () => {
    //     const im1 = document.querySelector('#ng1');
    //     const im2 = document.querySelector('#ng2');
    //     im1.style.transform = "translateY(0px)";
    //     im2.style.transform = "translateY(0px)";
    //     window.scrollTo(0, 0);
    // }
    useEffect(() => {
        window.scrollTo(0, 1)
    }, [])

    const optionsCarousel1 = {
        autoplay: true,
        autoplayTimeout: 6000,
        rewind: true,
        items: 1,
        nav: true,
        controlsText: ['<i class="fas fa-angle-left txt-white"></i>', '<i class="fas fa-angle-right txt-white"></i>'],
        mouseDrag: true
    }
    const optionsCarousel2 = {
        autoplay: true,
        autoplayTimeout: 6000,
        rewind: true,
        items: 1,
        nav: false,
        controlsText: ['<i class="fas fa-angle-left txt-white"></i>', '<i class="fas fa-angle-right txt-white"></i>'],
        mouseDrag: true
    }

    return (
        <div className='section'>
            <div className="home">
                <div className="top">
                    <TinySlider id="banHome" settings={optionsCarousel1} >
                        <div className="item" id="it1">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-12">
                                        <h1 className="display-3 text-md-start text-center txt-white bold fnt-T">
                                            <span className="txt-blue5">HIELO SECO</span> DEL BAJÍO
                                        </h1>
                                        <p className="fs-4 txt-white bold">
                                            Fabricamos y comercializamos hielo seco en <br/>
                                            diferentes presentaciones, satisfaciendo la <br/>
                                            demanda y necesidades de nuestros clientes.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="item" id="it2">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-12">
                                        <h1 className="display-3 text-md-start text-center txt-white bold fnt-T">
                                            <span className="txt-blue5">VENTAJAS</span>
                                        </h1>
                                        <p className="fs-4 txt-white bold">
                                            Cuando el hielo seco se sublima, va de estado <br/>
                                            sólido a gas sin pasar por estado líquido, por lo <br/>
                                            cual no deja residuos de humedad.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="item" id="it3">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-12">
                                        <h1 className="display-3 text-md-start text-center txt-white bold fnt-T">
                                            <span className="txt-blue5">VERSATILIDAD</span>
                                        </h1>
                                        <p className="fs-4 txt-white bold">
                                            Tiene infinidad de aplicaciones, abarcando <br/>
                                            desde sector farmacéutico, industrial, de alimentos <br/>
                                            hasta efectos especiales para eventos.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TinySlider>
                </div> {/* section */}
                <div className="whatis">
                    <div className="container-fluid">
                        <div className="row align-items-center justify-content-center">
                            <img src={ng1} alt="nugget" id="ng1" />
                            <img src={ng2} alt="nugget" id="ng2" />
                            <div className="col-xl-4 col-lg-12 p-0 bg-blue1 imgCol">
                                <img src={imgQHS} alt="qué es el hielo seco" className="w-100 d-block img" />
                            </div> {/* col */}
                            <div className="col-xl-8 col-lg-12 h-100 py-md-5">
                                <div className="row align-items-center justify-content-center py-xxl-5 py-xl-3 py-5">
                                    <div className="col-xl-8 col-lg-10 col-md-11">
                                        <h1 className="fs-7 text-md-start text-center txt-blue5 light fnt-T">
                                            <span className="txt-blue5">HIELO SECO</span> DEL BAJÍO
                                        </h1>
                                        <h2 className="fs-1 text-md-start text-center txt-black bold mb-4 fnt-T">
                                            ¿Qué es el Hielo Seco?
                                        </h2>
                                        <p className="txt-black regular mb-2">
                                            Se denomina hielo seco a la forma sólida del dióxido de carbono (CO2), el cual es encontrado comúnmente en la atmósfera; es también el gas que exhalamos al respirar y el gas utilizado por las plantas para la fotosíntesis.
                                        </p>
                                        <p className="txt-black regular mb-0">
                                            Recibe este nombre debido a que tiene apariencia de hielo común, pero cuando se sublima o pasa del estado sólido a gas, no deja ningún residuo de humedad o líquido, siendo esta una de sus principales características, pues lo convierte en una herramienta muy útil como agente refrigerante y en los procesos de limpieza criogénica; además tiene una capacidad refrigerante 3.3 veces mayor que el hielo de agua tradicional.
                                        </p>
                                    </div> {/* col */}
                                </div> {/* row */}
                            </div> {/* col */}
                        </div> {/* row */}
                        <div className="row row-cols-xl-5 row-cols-lg-3 row-cols-md-2 row-cols-1 justify-content-around">
                            <div className="col py-5 mb-0 c1">
                                <div className="icon" dangerouslySetInnerHTML={{__html: icon1}} />
                                <p className="fs-5 text-center txt-white regular mb-0 px-lg-5 px-md-4 fnt-T">Se sublima sin dejar residuos.</p>
                            </div> {/* col */}
                            <div className="col py-5 mb-0 c2">
                                <div className="icon" dangerouslySetInnerHTML={{__html: icon2}} />
                                <p className="fs-5 text-center txt-white regular mb-0 px-lg-5 px-md-4 fnt-T">Es inodoro e insípido.</p>
                            </div> {/* col */}
                            <div className="col py-5 mb-0 c3">
                                <div className="icon" dangerouslySetInnerHTML={{__html: icon3}} />
                                <p className="fs-5 text-center txt-white regular mb-0 px-lg-5 px-md-4 fnt-T">No es tóxico.</p>
                            </div> {/* col */}
                            <div className="col py-5 mb-0 c4">
                                <div className="icon" dangerouslySetInnerHTML={{__html: icon4}} />
                                <p className="fs-5 text-center txt-white regular mb-0 px-lg-5 px-md-4 fnt-T">Tiene efecto bacteriostático.</p>
                            </div> {/* col */}
                            <div className="col py-5 mb-0 c5">
                                <div className="icon" dangerouslySetInnerHTML={{__html: icon5}} />
                                <p className="fs-5 text-center txt-white regular mb-0 px-lg-5 px-md-4 fnt-T">Su temperatura es de: -78 °C (-109,3 °F).</p>
                            </div> {/* col */}
                        </div> {/* row */}
                    </div> {/* cont */}
                </div> {/* section */}
                <div className="presentation">
                    <div className="container-fluid">
                        <div className="row align-items-center justify-content-center dots">
                            <div className="col-xl-4 col-lg-5 p-md-5 p-4">
                                <p className="fs-1 text-md-start text-center txt-blue1 bold mb-1 fnt-T">
                                    PRESENTACIONES
                                </p>
                                <h1 className="fs-7 text-md-start text-center txt-blue5 light fnt-T">
                                    <span className="txt-blue5">HIELO SECO</span> DEL BAJÍO
                                </h1>
                            </div> {/* col */}
                            <div className="col-xl-8 col-lg-7 h-100">
                                <div className="row">
                                    <TinySlider2 className="col-12 p-0" id="banHomePres" settings={optionsCarousel2} >
                                        <div className="item" id="pres1">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <h1 className="fs-2 text-center m-0 txt-white bold fnt-T fst-italic">
                                                            BLOCK
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item" id="pres2">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <h1 className="fs-2 text-center m-0 txt-white bold fnt-T fst-italic">
                                                            NUGGET
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="item" id="pres3">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <h1 className="fs-2 text-center m-0 txt-white bold fnt-T fst-italic">
                                                            RICE
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TinySlider2>
                                </div> {/* row */}
                            </div> {/* col */}
                        </div> {/* row */}
                    </div> {/* cont */}
                </div> {/* section */}
                <div className="applications">
                    <div className="container-fluid">
                        <div className="row py-5">
                            <div className="col-12 py-md-5">
                                <h2 className="display-4 text-center fst-italic bold txt-white m-0 lh-1 fnt-T">
                                    PRINCIPALES APLICACIONES
                                </h2>
                                <p className="text-center fst-italic txt-white regular m-0">
                                    El hielo seco ofrece diversas ventajas para <b>sectores comerciales, de salud y medicina e industriales.</b>
                                </p>
                            </div> {/* col */}
                        </div> {/* row */}
                        <div className="row apl">
                            <div className="col-lg-4 py-lg-5 bg-blue3">
                                <div className="p-5 p-4">
                                    <h3 className="fs-3 bold txt-white fnt-T">Conservación <br/>de alimentos</h3>
                                    <a href={process.env.PUBLIC_URL+'/aplicaciones'} className="btnIr5 mx-0 mt-3 fnt-T">DESCUBRE MÁS</a>
                                </div> {/* info */}
                            </div> {/* col */}
                            <div className="col-lg-4 py-lg-5 bg-blue3">
                                <div className="p-5 p-4">
                                    <h3 className="fs-3 bold txt-white fnt-T">Limpieza <br/>criogénica</h3>
                                    <a href={process.env.PUBLIC_URL+'/limpieza-criogenica'} className="btnIr5 mx-0 mt-3 fnt-T">DESCUBRE MÁS</a>
                                </div> {/* info */}
                            </div> {/* col */}
                            <div className="col-lg-4 py-lg-5 bg-blue3">
                                <div className="p-5">
                                    <h3 className="fs-3 bold txt-white fnt-T">Destape de <br/>pozos profundos</h3>
                                    <a href={process.env.PUBLIC_URL+'/aplicaciones'} className="btnIr5 mx-0 mt-3 fnt-T">DESCUBRE MÁS</a>
                                </div> {/* info */}
                            </div> {/* col */}
                        </div> {/* row */}
                    </div> {/* cont */}
                </div> {/* section */}
                <div className="warning">
                    <div className="container-fluid">
                        <div className="row dots">
                            <div className="col-xxl-2 col-lg-3 py-5 bg-blue4">
                                <div className="icon" dangerouslySetInnerHTML={{__html: icon6}} />
                            </div> {/* col */}
                            <div className="col-xxl-10 col-lg-9 py-lg-5">
                                <div className="row align-items-center py-5">
                                    <div className="col-xl-7 col-lg-10 offset-lg-1">
                                        <p className="d-block fs-1 regular txt-blue4 fnt-T">
                                            LA MANIPULACIÓN Y USO DE HIELO SECO <b>DEBE SER CON PRECAUCIÓN</b>, TE RECOMENDAMOS <b>TOMAR MEDIDAS DE SEGURIDAD</b>.
                                        </p>
                                    </div>
                                    <div className="col-xl-2 col-lg-10 offset-xl-0 offset-lg-1">
                                        <a href={process.env.PUBLIC_URL+'/recomendaciones'} className="btnIr1 m-0 fs-3 fnt-T">VER MÁS</a>
                                    </div>
                                </div>
                            </div> {/* col */}
                        </div> {/* row */}
                    </div> {/* cont */}
                </div> {/* section */}
            </div> {/* home */}
        </div>
    )
}